<form [formGroup]="selectRolesForm">
    <ng-container *ngFor="let role of roles">
        <app-checkbox
            *ngIf="canManageRestrictedRoles || (role !== superAdminRole && role !== alternativeRole)"
            [formControlName]="role"
            [text]="getRoleText(role)"
            [disabled]="(role === superAdminRole || role === alternativeRole) && !canAssignRestrictedRoles"
            (ngModelChange)="roleChange(role, $event)"
        />
    </ng-container>
</form>
